module.exports = __webpack_public_path__ + "img/weather.56c46d80.svg";